var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-time"},[_c('span',{staticClass:"chat-item"},[_vm._v(_vm._s(_vm._f("filterDate")(_vm.date)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }